import ViewConstructor from './../components/ViewConstructor';
import CaseCard from './../components/CaseCard.js';
import { 
  getUrlParameter,
  flattenMultiArray,
} from './../../_util.js';

import Cookie from 'js-cookie';

/** Category Page renders the list of cases within the category */
class CategoryPage extends ViewConstructor {
  /** 
  constructor

  Calls the ViewConstructor class and adds it's mount point.
  @param {string} mount - id of mount element 
  @param {object} initiated api constructor
  */
  componentDidMount() {
    this.updateState({
      currentPage: 1,
      currentRouteState: undefined,
      currentCategory: undefined,
      currentCategoryId: undefined,
      cases: {},
      casesObject: {},
      galleryRef: undefined,
      maxPagination: 7,
    });

    this.toggleLoading(true);
  }

  componentDidEnter() {
    super.componentDidEnter();
    $(window).trigger('category-page-enter');
  }

  /**
    This method checks the url params for current "pagination" of results. Then it will do the math to see which startingCase to use by sequence_value of the cases and the setting currently hardcoded. 

    So if the URL says we're on page 2 and we are displaying six cases at a time, the next starting case will be sequence_value 7.

    - fires update title function titleUpdate
    - Runs template creation
    - Fires off function to see if cases on page need to be updated caseUpdate. API Call here
    - Pagination check and event listeners. 
  */
  loadSection(newRouteState, galleryConfig) {
    const that = this;
    
    let title = this.getTitle(newRouteState, galleryConfig.state);
    this.updateTitle(title);

    let currentCategory = getCurrentCategoryId(newRouteState, galleryConfig.state);

    let $ref = $(`#${ this.state.generatedId } .view__wrapper`);
    $ref.find('.case-card').remove();

    if (currentCategory) {
      this.state.currentCategoryId = currentCategory.category_id;
      this.state.currentCategory = currentCategory;

      this.state.gallery = galleryConfig;
    }
    function getCurrentCategoryId(nextRoute, galleryState) {
      let allSubcategories = [];
      let currentSection = undefined;
      let nextRouteNoParam = nextRoute.path.split('?')[0];

      if (nextRouteNoParam && galleryState.categories.length) {
        for (let i = 0; i < galleryState.categories.length; i++) {
          allSubcategories.push(galleryState.categories[i].subcategories);
        }
        
        allSubcategories = flattenMultiArray(allSubcategories);

        let foundCategory = $.grep(allSubcategories, (subcategory) => subcategory.category_canonical_url === decodeURI(nextRouteNoParam));

        if (foundCategory.length) {
          currentSection = foundCategory[0];
        }

        return currentSection;
      }
    }

    if (newRouteState) {
      this.state.currentRouteState = newRouteState;
      this.state.galleryRef = galleryConfig;
    }

    this.getCases(function(cases){
      that.updateCases(cases);
      that.state.gallery.update({
        cases: cases,
      });
      that.generatePagination();
      galleryConfig.addLinkEventListeners();
      that.toggleLoading(false);

      let metaTitle = `${cases.category_name} Before & After Photo Gallery | ${that.state.gallery.state.practice.locality.city}, ${that.state.gallery.state.practice.locality.state} | ${that.state.gallery.state.practice.name}`;
      let metaDescription = `View before-and-after ${cases.category_name} pictures of ${that.state.gallery.state.practice.name}'s patients. Photos depict the excellent results patients have come to expect from ${that.state.gallery.state.practice.name}.`;
      that.updateMeta(metaTitle, metaDescription);

      that.updateCanoncial(window.location.origin + cases.category_canonical_url);
      $ref.find('.category__consultation__btn').html(that.cloneConsultationButton());
      that.state.gallery.update({
        currentCategory: cases.category_id
      });
    });
  }

  /**
  updateTitle
  - This will update the current category title. This is called when cases are returned. There's some logic here to check if the title already exists on the page. If so it will not overwrite. 
  */
  updateTitle(newTitle) {
    //let titleRef = $(`#${ this.state.generatedId } .category__title`);
    let titleRef = $(`#photo-gallery__title`);

    if (titleRef.text() !== newTitle && newTitle && newTitle !== '') {
      titleRef.text(newTitle);
    }
  }

  /**
  getTitle method
  - This is where we see if we can preload a title. We pass in the newRouteState and the galleries current state. 
  - Check against the gallery state to see if we can find the current gallery object. 

  @returns either undefined if the title isn't found, or will return the string of the title.
  */
  getTitle(newRouteState, galleryState) {
    let allSubcategories = [];
    let title = undefined;

    if (newRouteState.path && galleryState.categories.length) {
      for (let i = 0; i < galleryState.categories.length; i++) {
        allSubcategories.push(galleryState.categories[i].subcategories);
      }
      
      allSubcategories = flattenMultiArray(allSubcategories);

      let foundCategory = $.grep(allSubcategories, (subcategory) => subcategory.category_canonical_url === decodeURI(newRouteState.path));

      if (foundCategory.length) {
        title = foundCategory[0].category_name;
      }

      return title;
    }

    return title;
  }

  /**
  Helper method which grabs the current url param for 'page'.

  - If it doesn't exist this returns 1 // assuming the page is the first page
  - if "all" is the value, it returns null, so we can check against it and cancel actions if need be
  - Or it returns the value of the page
  */
  getCurrentPage() {
    let currentPage = getUrlParameter('pagination');

    if (!currentPage) {
      return 1;
    } else if (currentPage === 'all') {
      return null;
    } else {
      return parseInt(currentPage, 10);
    }
  }

  resetCases() {
      let $ref = $(`#${ this.state.generatedId } .view__wrapper`);
      $ref.find('.case-card').remove();

      this.toggleLoading(true);
  }

  /**
  getCases 
  This will get the specified number of cases as defined in the options config in the constructor. 
  @param nextRequest - should have the gallery passed object that contains the URL of the next path and possibly the id of the current category. 
  */
  getCases(cb) {
    let that = this;
    let currentPage = this.getCurrentPage();
    let firstReturnedPosition = (currentPage - 1) * this.state.casesPerPage + 1;

    if (this.state.currentCategoryId) {

      if (currentPage === null) {
        this.getAllCases();
        return;
      }

      let requestObject = {
        category_id: parseInt(this.state.currentCategoryId, 10),
        first_returned_position: firstReturnedPosition,
        case_count: this.state.casesPerPage,
      };

      this.state.api.getCases(requestObject, function(res) {
        that.state.cases = res;

        if (typeof cb === 'function') {
          cb(res);
          $(window).trigger('category-page-data-loaded');
        }
      });

    } else {
      let casesRequestObject = {
        first_returned_position: firstReturnedPosition,
        case_count: this.state.casesPerPage,
        category_url: decodeURI(window.location.pathname),
      };

      this.state.api.getCases(casesRequestObject, (res) => {
        that.state.cases = res;
        if (typeof cb === 'function') {
          cb(res);
          $(window).trigger('category-page-data-loaded');
        }
      });
    } // else if just a path and not last path?
  }

  /**
  This is fired when view all cases button/link is clicked. Since the API is capped at 100 cases per request, this will check to see if there are greater than 100 cases within the category and then queue up a list of requests to make and generate and append all cases to screen. 
  
  - checks if over 100 cases in category
  - creates a queue of requests to make
  - generates and appends cases to screen after each request
  - this hides the current pagination
  - resets the query variable. 
  */
  getAllCases() {
    if (this.state.currentCategoryId) {
      this.toggleLoading(true);
      var queue = [];
      var that = this;

      var amountOfRequests = Math.ceil(this.state.cases.cases_available / 100);

      // hide pagination features
      $(`#${ this.state.generatedId } .category__pagination`).fadeOut(200);

      if (window.location.search.indexOf('all') === -1) {
        // update URL in browser if it's not already there
        history.pushState(null, null, window.location.pathname + '?pagination=all');

        this.state.gallery.update({
          currentCategoryCanonical: window.location.pathname + '?pagination=all',
        });
      }

      for (let i = 0; i < amountOfRequests; i++) {
        let firstReturnedPosition = 1;

        if (i > 0) {
          firstReturnedPosition = (i * 100) + 1;
        }

        var requestObject = {
          category_id: parseInt(this.state.currentCategoryId, 10),
          first_returned_position: firstReturnedPosition,
          case_count: 100,
        };

        that.state.api.getCases(requestObject, function(res) {
          that.state.cases = res;
          that.updateCases(res, (ref, cases, cb) => {
            if (i === 0) {
              // if first set of response replace whatever is in the cases section
              $(ref).html(cases);
              that.state.gallery.addLinkEventListeners();
              cb();
              $(window).trigger('category-page-data-loaded');
            } else {
              $(ref).append(cases);
              that.state.gallery.addLinkEventListeners();
              cb();
              $(window).trigger('category-page-data-loaded');
            }

            that.toggleLoading(false);
          });
        });
      }
    }
  }

  /**
  updateCases 
  @params {object} getCasesResponse - response returned by the API
  @params {function} callback - optional. If you pass a call back it will pass the cases ref and the cases to you. If you don't pass this, it will automatically update the on page cases itself. 

  - This loops through all the cases returned by the api. It will check the title and update it if different. 
  - It creates all the case cards for the returned cases
  */
  updateCases(getCasesResponse, cb) {
    let that = this;
    if (getCasesResponse !== undefined) {
      let parentRef = $(`#${ this.state.generatedId } .category__cases--wrapper`);
      let ref = $(`#${ this.state.generatedId } .category__cases`);
      let title = getCasesResponse.category_name;

      let hadCasesAlready = (this.state.gallery.state.cases && this.state.gallery.state.cases.category_id !== undefined);

      if (this.state.gallery) {
        this.state.gallery.update({
          cases: getCasesResponse,
        });
        
        // if did not have cases before... run the filters
        if (!hadCasesAlready) {
          $(document).trigger('update-filters');

          // otherwise check if in same category, if not, run the filters
        } else if (getCasesResponse.category_id !== parseInt(this.cookie.get('gallery--currentCategory'), 10)) {
          $(document).trigger('update-filters');
        }

        this.cookie.set('gallery--currentCategory', that.state.gallery.state.cases.category_id);
      }

      this.updateTitle(title);

      let caseTemplates = ``;
      let filteredCases = getCasesResponse.cases;

      let cases = filteredCases.sort((a, b) => a.sequence_value - b.sequence_value);
      let currentUserCookie = Cookie.getJSON('gallery-user');

      for (let i = 0; i < cases.length; i++) {
        let currentCase = cases[i];
        let isAFavoriteCase = currentUserCookie && currentUserCookie.favorites.includes(currentCase.case_id);
        caseTemplates += CaseCard(this.state.api.state.url, currentCase, isAFavoriteCase, this.state.gallery.state.cases.category_name, this.state.gallery.state.practice);
      }

      parentRef.css({ height: ref.height() });

      function afterUpdateCases() {
        that.toggleLoading(false);
        that.state.gallery.addLinkEventListeners();
        updateParentHeight();

        setTimeout(() => {
          updateParentHeight();
        }, 1000);
        
        $(`#${ that.state.generatedId } .category__cases__case`).off().on('click', function(e) {
          let targetId = $(this).attr('data-id');
          let elementClassname = '';

          if (e.target.attributes.class && e.target.attributes.class.value) {
            elementClassname = e.target.attributes.class.value;
          }

          function wasAFavClick(currentElClassName) { 
            let allFavClasses = ['gallery-favorites', 'heart-icon', 'add', 'favorite'];
            let wasFound = false;

            for (let i = 0; i < allFavClasses.length; i++) {
              if (currentElClassName.indexOf(allFavClasses[i]) !== -1) {
                wasFound = true;
              }
            }

            return wasFound;
          }
          
          if (e && !wasAFavClick(elementClassname)) {
            $(`#${ targetId }`).trigger('click');
          }
        });
      }

      function updateParentHeight(){
        setTimeout(()=>{
          parentRef.animate({
            height: ref.height(),
          }, 150);

          setTimeout(() => {
            parentRef.css({ height: 'auto' });
          }, 200);
        }, 250);
      }

      if (typeof cb === 'function') {

        cb(ref, caseTemplates, afterUpdateCases);
      } else {
        ref.html(caseTemplates);
        afterUpdateCases();
      }
    } else {
      return '';
    }
  }

  /**
  Category Pagination.
  This gets current page variable from URL, if not defined, it will be page 1. 
  if there are less cases in the cases object than there are casesPerPage, no pagination will display. 
  */
  generatePagination() {
    const that = this;
    let $paginationRef = $(`#${ this.state.generatedId } .category__pagination`);
    let currentPage = this.getCurrentPage();
    let paginationHtml = '';

    if (currentPage === null) {
      return;
    }


    let amountOfCases = this.state.gallery.state.cases.cases_available;
    let displayedCases = this.state.casesPerPage;

    let maxNumberOfPages = Math.ceil(amountOfCases / displayedCases); // if we have 18 cases and cases to be shown are 6, then create three buttons. 
    
    let amountOfCasesAvailable = this.state.gallery.state.cases.cases_available;

    if (getUrlParameter('filters')) {
      let totalCaseCount = 0;

      this.state.gallery.state.cases.filters.map((filter, index) => {
        if (filter.active) {
          filter.filter_values.map((filterVal) => {
            if (filterVal.selected) {
              totalCaseCount += filterVal.case_count;
            }
          });
        }
      });

      amountOfCasesAvailable = totalCaseCount;
    }

    if (this.state.gallery.state.cases.cases_available && amountOfCasesAvailable > this.state.casesPerPage) {

      paginationHtml += `<div class="category__pagination__count">Page &nbsp;<span class="category__pagination__count__current">${currentPage}</span>&nbsp;of&nbsp;${maxNumberOfPages}</div>`;
      // adding "previous" button
      paginationHtml += '<div class="category__pagination__buttons"><span class="category__pagination__button-functional prev" data-value="prev">&nbsp;</span>';

      for (let i = 0; i < maxNumberOfPages; i++) {
        let className = '';
        if (currentPage - 1 === i) {
          className = 'active';
        }
        paginationHtml += `<span class="${ className } category__pagination__button" data-pagination="${ i + 1 }">${ i + 1 }</span>`;

        // if second button add hidden ellipses || if second from last
        if (i === 1 || i === maxNumberOfPages - 2) {
          paginationHtml += `<span class="ellipses category__pagination__button disabled" style="display: none;">...</span>`;
        }
      }

      // adding "next" button
      paginationHtml += '<span class="category__pagination__button-functional next" data-value="next">&nbsp;</span></div>';

      paginationHtml += '<div class="category__pagination__all">View All</div>';
    }

    $paginationRef.html(paginationHtml);

    this.handleVisiblePagination();

    $paginationRef.find('.category__pagination__button').off().on('click', handlePagniationClick);
    $paginationRef.find('.category__pagination__button-functional').off().on('click', handleFunctionalPaginationClick);
    $paginationRef.find('.category__pagination__all').off().on('click', handleViewAllClick);

    function handleFunctionalPaginationClick(e) {
      if (e) { e.preventDefault(); }

      let type = $(this).attr('data-value');
      let currentPage = parseInt(getUrlParameter('pagination'), 10) || 1;

      switch(type) {
        case "prev":
          if (currentPage - 1 >= 1) {
            let newPage = currentPage - 1;

            that.toggleLoading(true);
            that.updatePaginationAndGetCases(newPage);
          }
          break;

        case "next":
          if (currentPage + 1 <= maxNumberOfPages) {
            let newPage = currentPage + 1;

            that.toggleLoading(true);
            that.updatePaginationAndGetCases(newPage);
          }
          break;
        default:
          break;
      }
    }

    function handlePagniationClick(e) {
      if (e) { e.preventDefault(); }

      let newPage = $(this).attr('data-pagination');

      if (newPage && !$(this).hasClass('active')) {
        that.toggleLoading(true);
        that.updatePaginationAndGetCases(newPage);
      }
    }

    function handleViewAllClick(e) {
      if (e) { e.preventDefault(); }

      $(window).trigger('pagination-change');
      that.getAllCases();
    }
  }

  /**
    handleVisiblePagination
    This method will append/remove ellipses based on current page
  */
  handleVisiblePagination() {
    const that = this;
    let buttonCount = $(`#${ that.state.generatedId } .category__pagination__buttons`).children();
    let currentPage = parseInt(getUrlParameter('pagination'), 10) || 1;

    // not counting the ellipses in this check
    let amountOfNextToButtons = $(window).width() > 1024 ? 2 : 1;


    if ((buttonCount.length - 2) - amountOfNextToButtons > that.state.maxPagination) {
      buttonCount.each(function(index, button) {
        // if not first or last
        if (index !== 1 && index !== (buttonCount.length - 2)) {
          let currentButtonPage = $(button).attr('data-pagination');

          // if current button has the data-page attribute
          if (currentButtonPage) {
            currentButtonPage = parseInt(currentButtonPage, 10);

            // if not the first four cases
            if (currentPage < 5 && currentButtonPage < 5) {
              $(button).show();

            // if within 2 of the current page button will be displayed
            } else if (Math.abs(currentButtonPage - currentPage) <= amountOfNextToButtons) {
              $(button).show();
            } else {
              $(button).hide();
            }
          }
        }
      });

      // if the second page is hidden add/show ellipses button
      if ($(buttonCount[2]).is(':hidden')) {
        $(buttonCount[3]).show();
      } else {
        $(buttonCount[3]).hide();
      }

      // if the 3rd from last clickable button is hidden, it will show that last ellipses. 
      if ($(buttonCount[buttonCount.length - 4]).is(':hidden')) {
        $(buttonCount[buttonCount.length - 3]).show();

      // otherwise it will hide the ellipses
      } else {
        $(buttonCount[buttonCount.length - 3]).hide();
      }
    }
  }

  /**
    There are three functional methods for handling pagination events. All which end where we need to update page query in url, fetch cases and get cases. Moving duplicate code into shared functional method. 
  */
  updatePaginationAndGetCases(newPage) {
    const that = this;
    let $paginationRef = $(`#${ this.state.generatedId } .category__pagination`);
    let $paginationButtons = $paginationRef.find('.category__pagination__button');

    $paginationRef.find('.category__pagination__count__current').text(newPage);
    // removing pagination active class and adding it to the appropriate button.
    $paginationButtons.removeClass('active');
    $paginationButtons.each((index, button) => {
      if ($(button).attr('data-pagination') === newPage.toString()) {
        $(button).addClass('active');
      }
    });

    history.pushState(null, null, window.location.pathname + '?pagination=' + newPage);
      
    if (that.state.gallery) {
      that.state.gallery.update({
        currentCategoryCanonical: window.location.pathname + '?pagination=' + newPage,
      });
    }

    that.handleVisiblePagination();
    
    $(window).trigger('pagination-change');

    that.getCases((theCases) => {
      that.updateCases(theCases);
      
      that.state.gallery.update({
        cases: theCases,
      });
      that.state.galleryRef.addLinkEventListeners();
      this.toggleLoading(false);
    });
  }

    /**
     Overrides ViewConstructor's render method which renders a generic template. Since this page relies on the API other functions update the view.
    */
    render() {
        return `
        <div class="category">
            <p><strong><em>*Keep in mind that each patient is unique and your results may vary.</em></strong></p>
            <hr />
            <div class="category__cases--wrapper">
                <div class="category__cases"></div>
            </div>
            <div class="category__consultation__btn"></div>
            <div class="category__pagination"></div>
            <div class="category__links" style="display: none;"></div>
        </div>
        `;
    }
}

export default CategoryPage;


// WEBPACK FOOTER //
// ./src/scripts/site/gallery-views/CategoryPage.js